import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ImageIcon, X } from "lucide-react";
import { imgUrl, refreshCategories } from "@/components/landing/useProducts";
import { ImageUpload } from "./ImageUpload";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POSITIONS = [["object-top", "Top"], ["object-center", "Centre"], ["object-bottom", "Bottom"]];

export const CategoryCover = ({ category, headers }) => {
  const [open, setOpen] = useState(false);
  const save = async (cover, cover_position = category.cover_position || "object-center") => {
    try {
      await axios.put(`${API}/admin/categories/${category.id}/cover`, { cover, cover_position }, { headers });
      await refreshCategories();
      toast.success(cover ? "Category picture updated" : "Category picture removed — tile uses the first product");
    } catch {
      toast.error("Could not save the category picture.");
    }
  };
  return (
    <div data-testid={`category-cover-${category.id}`} className="mb-3 flex flex-wrap items-center gap-3">
      <button type="button" data-testid={`category-cover-toggle-${category.id}`} onClick={() => setOpen((o) => !o)} className="inline-flex items-center gap-2 h-8 px-3 rounded-full border border-[#e3e2dc] hover:border-[#0a0a0b] font-mono-d text-[9px] uppercase tracking-[0.15em]">
        <ImageIcon size={12} /> {category.cover ? "Homepage tile picture" : "Set homepage tile picture"}
      </button>
      {category.cover && (
        <>
          <span className="h-10 w-8 rounded-md overflow-hidden border border-[#e3e2dc]"><img src={imgUrl(category.cover)} alt="" className={`h-full w-full object-cover ${category.cover_position || "object-center"}`} /></span>
          <select data-testid={`category-cover-position-${category.id}`} value={category.cover_position || "object-center"} onChange={(e) => save(category.cover, e.target.value)} className="h-8 px-2 rounded-lg bg-[#ffffff] border border-[#e3e2dc] font-mono-d text-[9px] uppercase tracking-[0.15em]">
            {POSITIONS.map(([v, l]) => <option key={v} value={v}>Focus: {l}</option>)}
          </select>
          <button type="button" data-testid={`category-cover-remove-${category.id}`} onClick={() => save(null)} className="inline-flex items-center gap-1 font-mono-d text-[9px] uppercase tracking-[0.15em] text-[#5f5e5a] hover:text-[#ff2a85]"><X size={11} /> Remove</button>
        </>
      )}
      {open && (
        <div className="w-full max-w-xs">
          <ImageUpload headers={headers} images={category.cover || ""} onChange={(url) => { save(url); setOpen(false); }} testId={`category-cover-upload-${category.id}`} />
          <p className="mt-1 text-[11px] text-[#5f5e5a]">Overrides the first product's photo on the homepage “Shop by category” tile.</p>
        </div>
      )}
    </div>
  );
};
